export const CHECK_LOGIN = "CHECK_LOGIN";
export const AUTH_FAILED = "AUTH_FAILED";
export const AGREEMENT = "AGREEMENT";
export const CODE_LOGIN = "CODE_LOGIN";
export const CHANGE_LOGO = "CHANGE_LOGO";
export const CHANGE_DOWNLOAD_STATUS = "CHANGE_DOWNLOAD_STATUS";
